module.exports = __webpack_public_path__ + "static/media/get-ride.0ce5a6e6.png";